import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import ApplicationNameChangeModal from "../ApplicationNameChangeModal/ApplicationNameChangeModal";
import "./index.less";

const ApplicationNameChangeHeaderBar = () => {
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  const handleReadMoreClick = () => {
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  return (
    <>
      <div className="header-info-name-change-container">
        <span className="header-info-name-change-text">{t("change-of-name")}</span>
        <span className="header-info-name-change-text white"> {t("loly-to-twizz")}</span>
        <div className="header-info-name-change-button" onClick={handleReadMoreClick}>
          <Typography.Text className="header-info-name-change-button-text">{t("more-info")}</Typography.Text>
        </div>
      </div>
      <ApplicationNameChangeModal visible={modalVisible} onClose={handleCloseModal} />
    </>
  );
};

export default ApplicationNameChangeHeaderBar;
